import PropTypes from 'prop-types';
import { useMutation, useApolloClient } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { LOGOUT } from 'store/mutations';
import auth from 'utils/auth';

const LogoutMutation = ({ children }) => {
  const client = useApolloClient();
  const history = useHistory();
  const [logoutMutation, { loading }] = useMutation(LOGOUT);

  const logout = async () => {
    try {
      if (localStorage.accessToken) {
        await logoutMutation();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Could not clear the session properly');
    }

    try {
      await auth.logout();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('Could not log out properly');
    }
  };

  return children({ logout, loading, history, client });
};

LogoutMutation.propTypes = {
  children: PropTypes.func
};

export default LogoutMutation;
